export default "__VITE_ASSET__1GqXgYN5__"